import { createApp } from 'vue'
import commonMixin from './common/common.js';
import contactMixin from './common/contact.js';

createApp({
    mixins: [commonMixin, contactMixin],
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {
    }
}).mount('#app')